export const cpf = '999.999.999-99';

export const cnpj = '99.999.999/9999-99';

export const date = '99/99/9999';

export const dateTime = '99/99/9999 99:99';

export const phone = '(99) 9999-9999';

export const cellphone = '(99) 99999-9999';

export const uuid = '********-****-****-****-************';
